import { makeVar } from '@apollo/client'
import { Status } from '@egjs/flicking'

import { ReviewGroupsMediaFilter, UserReviewGroupsSort } from '@web/gql/graphql'

export const reviewTabFilterStateVar = {
  mediaFilter: makeVar<ReviewGroupsMediaFilter | undefined>(undefined),
  sort: makeVar<UserReviewGroupsSort>(UserReviewGroupsSort.VisitDateTimeDesc),
  placeCategoryId: makeVar<string | undefined>(undefined),
  regionCode: makeVar<string | undefined>(undefined),
  flickingStatus: makeVar<Status | undefined>(undefined),
}

export const USER_REVIEWGROUP_FILTER_DEFAULT = {
  mediaFilter: ReviewGroupsMediaFilter.All,
  sort: UserReviewGroupsSort.VisitDateTimeDesc,
}

export const cleanupReviewTabFilter = () => {
  reviewTabFilterStateVar.mediaFilter(undefined)
  reviewTabFilterStateVar.sort(UserReviewGroupsSort.VisitDateTimeDesc)
  reviewTabFilterStateVar.placeCategoryId(undefined)
  reviewTabFilterStateVar.regionCode(undefined)
  reviewTabFilterStateVar.flickingStatus(undefined)
}

export const reviewTabPageOwnerIdVar = makeVar<string | undefined>(undefined)
